export default __webpack_public_path__ + "static/media/nivid-logo-min.a930161a.png";